import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/** 路由切換時自動捲回頁面頂端 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname]);

  return null;
}